import { render, staticRenderFns } from "./run-form-item.vue?vue&type=template&id=6393a51a&"
import script from "./run-form-item.vue?vue&type=script&lang=ts&"
export * from "./run-form-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports